import React from "react";
import { connect } from "react-redux";
import LimitLine from "../../GameHeader/Stats/LimitLine";
import { formatNumber, formatNumberForceSigned } from "../../../lib/commonFunctions";

const IronBalance = ({ ironBalance }) => (
  <React.Fragment>
    <h3 className="title">Iron balance</h3>
    Iron-miners: <span className={ironBalance.production.miners > 0 ? "positive" : ""}>{formatNumberForceSigned(ironBalance.production.miners)}</span><br />
    {!!ironBalance.production.guilds && <>
      Guild: <span className={"positive"}>{formatNumberForceSigned(ironBalance.production.guilds)}</span><br />
    </>}
    Weapons production: <span className={ironBalance.consumption > 0 ? "negative" : ""}>{formatNumber(-ironBalance.consumption)}</span>
    <br />
    <LimitLine
      amount={ironBalance.limit.amount}
      limit={ironBalance.limit.limit}
      market={ironBalance.limit.market}
    />
  </React.Fragment>
);

const mapStateToProps = state => ({
  ironBalance: state.governorate.resourceBalances.iron,
});

export default connect(mapStateToProps)(IronBalance);
